import { AlertBox, Box, FlexBox, H1, StandardForm } from '@vp/swan'
import { useTranslation } from 'react-i18next'
import { ISSUE_DESCRIPTION_FIELDS } from '../../config/issue-description-fields'
import { useIssueDescription } from '../../hooks/use-issue-description'

export const IssueDescription = () => {
  const { t } = useTranslation()
  const { control, channel, intentId, entries, addFiles, removeEntry, submitError } = useIssueDescription()

  const renderCtx = { channel, intentId, entries, addFiles, removeEntry }

  return (
    <Box data-testid="step-issue-description">
      <H1 mb={7} fontSkin="title-headline">
        {t('contact_us.page.steps.issue_description.title')}
      </H1>
      <StandardForm>
        <FlexBox flexDirection="column">
          {ISSUE_DESCRIPTION_FIELDS.filter(({ condition }) => !condition || condition(renderCtx)).map(({ id, render }) => (
            <Box key={id} data-testid={`issue-field-${id}`}>
              {render(control, renderCtx)}
            </Box>
          ))}
        </FlexBox>
      </StandardForm>
      {submitError && (
        <Box data-testid="issue-description-submit-error">
          <AlertBox skin="error" mt={5}>
            {submitError}
          </AlertBox>
        </Box>
      )}
    </Box>
  )
}
